import type { HostConfigurationDto } from "../../types/HostConfigurationDto";
import type { HostConfigurationEntity } from "../../types/HostConfigurationEntity";

export const HostConfigurationDtoToEntity = ({ ...rest }: Readonly<HostConfigurationDto>): HostConfigurationEntity => {
    return { ...rest };
};
